import 'reflect-metadata';
import {jsonObject, jsonMember, jsonMapMember} from 'typedjson';

@jsonObject
export class IpRoute {

  private static count: number = 0;

  public Id: number = IpRoute.count++;

  @jsonMember({name: 'destination'})
  public Destination: string = '';

  @jsonMember({name: 'prefix'})
  public Prefix!: number;

  @jsonMember({name: 'gateway'})
  public Gateway?: string;

  @jsonMember({name: 'metric'})
  public Metric?: number;

  @jsonMapMember(String, String, {name: 'additionalAttributes'})
  public AdditionalAttributes!: Map<string, string>;

  constructor(route?: Partial<IpRoute>) {
    Object.assign(this, route);
    if (route?.AdditionalAttributes) {
      this.AdditionalAttributes = new Map<string, string>(route.AdditionalAttributes);
    }
  }
}
